import { TravelCurrencyCode } from '@graphql/generated';
import { useGeoBasedLocale } from './useGeoLocale';
import { mapCurrencyCodeToTravelCurrencyCode } from '@shared/utils/currency';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';

export const useTravelWhiteLabelCurrency = (eventCurrency?: TravelCurrencyCode | null): TravelCurrencyCode => {
  const { currency: localeCurrency } = useGeoBasedLocale();
  const [isAccommodationsPageCurrencyEnabled] = useIsFeatureEnabled('accommodationsPageCurrencyEnabled');

  if (isAccommodationsPageCurrencyEnabled && eventCurrency) {
    return eventCurrency;
  }

  return mapCurrencyCodeToTravelCurrencyCode(localeCurrency);
};
